import React, { Component } from "react";
import videojs from "@mux/videojs-kit";
import "@mux/videojs-kit/dist/index.css";

interface VideoPlayerProps {
  videoMuxPlaybackId: string;
  videoStartTime?: number;
}
interface VideoPlayerState {
  videoId: string;
  overlayImageSize: number;
}

class VideoPlayer extends Component<VideoPlayerProps, VideoPlayerState> {
  videoPlayerRef: React.RefObject<unknown>;
  player: any;
  constructor(props: VideoPlayerProps) {
    super(props);
    this.videoPlayerRef = React.createRef();
    this.state = {
      overlayImageSize: 0,
      videoId: this.props.videoMuxPlaybackId
    };
  }

  componentDidMount() {
    this.player = videojs(this.videoPlayerRef.current);
    this.player.ready(() => {
      if (this.props.videoStartTime) {
        this.player.currentTime(this.props.videoStartTime);
      }
      this.player.play();
    });
  }

  componentWillUnmount() {
    if (this.player) {
      this.player.dispose();
    }
  }

  shouldComponentUpdate(nextProps: any) {
    if (this.state.videoId != nextProps.videoMuxPlaybackId) {
      return true;
    } else return false;
  }

  componentDidUpdate(prevProps: any) {
    if (this.props.videoMuxPlaybackId !== this.state.videoId) {
      this.setState({
        videoId: this.props.videoMuxPlaybackId
      });
    }
  }

  render() {
    return (
      <div className="dv-imgdetails" style={{ height: "100%", width: "100%" }}>
        <video
          id="my-player"
          className="video-js vjs-16-9"
          controls
          //@ts-ignore
          ref={this.videoPlayerRef}
          preload="auto"
          width="100%"
          data-setup="{}"
          muted
          disablePictureInPicture
        >
          <source src={this.state.videoId} type="video/mux" />
        </video>
      </div>
    );
  }
}

export default VideoPlayer;
